import { PAGE_KEYS } from "../_core/pageKeys";
import { SECTION_KEYS } from "../_core/sectionKeys";
import { PAGE_TEMPLATE_TYPES, TEMPLATE_KEYS } from "../_core/templateTypes";

export default {
  key: TEMPLATE_KEYS.JAPAN,
  defaultLocale: "ja_JP",
  defaultCurrency: "JPY",
  checkout: {
    payment: {
      enabledMethods: ["online"],
      defaultMethod: "online",
      provider: "conflux",
      currency: "JPY",
    },
    continuePayment: {
      mode: "direct",
      provider: "conflux",
      paymentPath: "/payment",
    },
  },
  resources: {
    layoutHeaderUrl: "jp-layout-header",
    layoutFooterUrl: "jp-layout-footer",
    userHeaderUrl: "jp-layout-header",
    userFooterUrl: "jp-layout-footer",
  },
  pages: {
    [PAGE_KEYS.HOME]: {
      // type: PAGE_TEMPLATE_TYPES.COMPONENT,
      // component: () => import("./pages/HomePage.vue"),
      // layout: "default",
      type: PAGE_TEMPLATE_TYPES.LOWCODE,
      lowcodeUrl: "jp-shoppc",
      layout: "default",
    },
    [PAGE_KEYS.CART]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/CartPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.PRODUCT]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/ProductPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.PRODUCT_DETAIL]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/ProductPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.PRODUCT_LIST]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/ProductPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.PRODUCT_SEARCH]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/ProductPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.CATEGORY]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/CategoryPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.PAYMENT]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/PaymentPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.PAYMENT_SUCCESS]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/PaymentSuccessPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.ORDER_QUERY]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/OrderQueryPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.USER_CENTER]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/UserCenterPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.USER_COUPONS]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/UserCouponsPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.USER_PROFILE]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/UserProfilePage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.USER_ORDER_DETAIL]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/UserOrderDetailPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.LOGIN]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/LoginPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.PUBLIC_ORDER_DETAIL]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/UserOrderDetailPage.vue"),
      layout: "default",
    },
  },
  sections: {
    [SECTION_KEYS.NAVIGATION_BAR]: {
      component: () => import("./sections/NavigationBar.vue"),
    },
    [SECTION_KEYS.PAYMENT_HERO]: {
      component: () => import("./sections/PaymentHero.vue"),
    },
    [SECTION_KEYS.PAYMENT_CONTACT_ADDRESS]: {
      component: () => import("./sections/PaymentContactAddress.vue"),
    },
    [SECTION_KEYS.PAYMENT_REMARK_DELIVERY]: {
      component: () => import("./sections/PaymentRemarkDelivery.vue"),
    },
    [SECTION_KEYS.PAYMENT_METHODS]: {
      component: () => import("./sections/PaymentMethods.vue"),
    },
    [SECTION_KEYS.PAYMENT_ORDER_SUMMARY]: {
      component: () => import("./sections/PaymentOrderSummary.vue"),
    },
    [SECTION_KEYS.PAYMENT_ADDRESS_PICKER]: {
      component: () => import("./sections/PaymentAddressPicker.vue"),
    },
  },
};
